import type { Email } from "@src/types/api";

export function getEmailSentTimeMs(email: Pick<Email, "sentDateTime">): number | null {
  const raw = email.sentDateTime;

  if (raw == null || raw === "") return null;
  const t = Date.parse(typeof raw === "string" ? raw : String(raw));

  return Number.isFinite(t) ? t : null;
}

export function formatEmailSentTime(email: Pick<Email, "sentDateTime">): string | null {
  const ms = getEmailSentTimeMs(email);

  if (ms == null) return null;
  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(ms));
}
